export const setUrlQueryParams = ({ history, link, params }) => {
  const searchParams = new URLSearchParams(link ? '' : history.location.search)
  params.forEach(([paramName, paramValue]) => searchParams.set(paramName, paramValue))
  return { pathname: link ? link : history.location.pathname, search: `?${searchParams.toString()}` }
}
